export const FLAG_NAME: Record<string, string> = {
  SGD: 'sg',
  MYR: 'my',
  BDT: 'bd',
  CNY: 'cn',
  HKD: 'hk',
  INR: 'in',
  KRW: 'kr',
  PHP: 'ph',
  THB: 'th',
  TWD: 'tw',
  VND: 'vn',
  'VND-CASH': 'vn',
  IDR: 'in'
};

export const DROPDOWN_FIELDS = [
  'vnd_district',
  'vnd_payment_mode',
  // 'relationship',
  'nationality',
  'bank_country'
];

export const BANK_FIELDS = [] as const;

export const BENEFICIARY_FIELDS = [] as const;

export const LOGIN_URL = '/auth/login';

export const TOKEN_KEY = 'access_token';

export const QUERY_PARAMS = {
  FROM_URL: 'from_url'
};

export const NOT_ALLOW_REMITTER_STATUSES = ['pending_kyc', 'inactive'];
